export default "__VITE_ASSET__CKFIuaOO__"